




import _ from 'lodash';
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      searchText: '',
    };
  },
  watch: {
    searchText: {
      handler: _.debounce(function(this: any) {
        this.triggerSearch();
      }, 1000),
      deep: true,
    },
  },
  methods: {
    triggerSearch() {
      this.$emit('search', this.searchText);
    },
  },
});
